import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  text: {
    fontSize: 16,
    padding: 8,
    fontWeight: 'bold',
  },
}));
